/** Pages that take a cart id, from the page routes in service/site.ts. */
const CART_PAGES = [
  'get',
  'get-mobile',
  'make',
  'create',
  'share',
  'receive',
  'receive-mobile',
  'embed',
  'review',
  'widget',
];

/** Production links work everywhere; the staging and dev hosts only exist in those builds. */
const cartHosts = (): string[] => {
  const nodeEnv: string = process.env.NODE_ENV || '';

  switch (nodeEnv) {
    case 'staging':
      return ['share-a-cart.com', 'cart-a-share.com'];
    case 'production':
    case 'classroom':
      return ['share-a-cart.com'];
    default:
      return ['share-a-cart.com', 'localhost'];
  }
};

/** [https://][www.]share-a-cart.com[:port]/[locale/]<page>/<cart id>, then end or /?# */
const cartLink = (): RegExp => {
  const hosts = cartHosts()
    .map((host) => host.replace(/\./g, '\\.'))
    .join('|');

  return new RegExp(
    `^(?:https?://)?(?:www\\.)?(?:${hosts})(?::\\d+)?/(?:[a-z]{2}/)?(?:${CART_PAGES.join('|')})/([a-z0-9]{1,9})(?:[/?#]|$)`,
    'i',
  );
};

/**
 * Pulls the cart id out of a pasted Share-A-Cart link: share-a-cart.com/make/AKGUX -> AKGUX.
 * Returns null for anything else, leaving plain cart ids and search queries on their own paths.
 */
export const parseCartIdFromUrl = (value: string): string | null => {
  const match = cartLink().exec(value.trim());

  return match ? match[1].toUpperCase() : null;
};
